import TagAdd from "./component";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useApiRequest } from "../Login/Hooks/useApiRequest";
const TagRechargeContainer = () => {
  const navigate = useNavigate();
  const { makeApiRequest } = useApiRequest();

  const [tokenNumber, setTokenNumber] = useState("");
  const [pageCount, setPageCount] = useState(1);
  const [secretkey, setSecretkey] = useState("");
  const [taguid, setTaguid] = useState("");
  const [loader, setLoader] = useState(false);
  const [tagActive, setTagActive] = useState(false);
  const [askLink, setAskLink] = useState(false);

  //============================
  // SEARCH TOKEN
  //============================
  const handleResponseSearchToken = (response) => {
    setLoader(false);
    const data = response.data.response;
    setTaguid(data.uid);
    setTagActive(data.active);
    localStorage.setItem("TagUUID", data.uid);

    if (data.active) {
      navigate(`/taghistory/${data.uid}`);
    } else {
      toast.error("TAG NOT ACTIVE", {
        position: "top-right",
        autoClose: 1000,
      });
    }
  };

  const handleErrorSearchToken = (err) => {
    setLoader(false);
    toast.error(err?.response?.data?.statusMessage || "Error occurred", {
      position: "top-right",
      autoClose: 1000,
    });
  };

  const SearchToken = () => {
    const UserJWTAuth = localStorage.getItem("UserJWTAuth");
    setLoader(true);

    makeApiRequest({
      url: `${process.env.REACT_APP_API_BASE_URL}/auth/tag/search?qrData=${tokenNumber}`,
      method: "GET",
      headers: {
        Authorization: `Bearer ${UserJWTAuth}`,
      },
      handleSuccess: handleResponseSearchToken,
      handleError: handleErrorSearchToken,
    });
  };

  //============================
  // SECRET KEY LINK
  //============================
  const handleResponseSecretKeyLink = (response) => {
    setLoader(false);
    setPageCount(pageCount + 1);
    navigate("/taglist");
  };

  const handleErrorSecretKeyLink = (err) => {
    setLoader(false);
    navigate("/taglist");
    toast.error(err?.response?.data?.statusMessage || "Error occurred", {
      position: "top-right",
      autoClose: 1000,
    });
  };

  const SubmitSecretKeyLink = () => {
    const UserJWTAuth = localStorage.getItem("UserJWTAuth");
    setLoader(true);

    makeApiRequest({
      url: `${process.env.REACT_APP_API_BASE_URL}/auth/tag/${taguid}/link`,
      method: "POST",
      headers: {
        Authorization: `Bearer ${UserJWTAuth}`,
        "x-tag-secret": `${secretkey}`,
      },
      data: { request: { replaceCurrentAccount: false } },
      handleSuccess: handleResponseSecretKeyLink,
      handleError: handleErrorSecretKeyLink,
    });
  };

  //============================
  // SECRET KEY ACTIVE
  //============================
  const handleResponseSecretKeyActive = (response) => {
    setLoader(false);
    setPageCount(pageCount + 1);
    SubmitSecretKeyLink();

    setTimeout(() => {
      navigate("/taglist");
    }, 1000);
  };

  const handleErrorSecretKeyActive = (err) => {
    setLoader(false);
    navigate("/taglist");
    toast.error(err?.response?.data?.statusMessage || "Error occurred", {
      position: "top-right",
      autoClose: 1000,
    });
  };

  const SubmitSecretKeyActive = () => {
    const UserJWTAuth = localStorage.getItem("UserJWTAuth");
    setLoader(true);

    makeApiRequest({
      url: `${process.env.REACT_APP_API_BASE_URL}/auth/tag/${taguid}/active`,
      method: "POST",
      headers: {
        Authorization: `Bearer ${UserJWTAuth}`,
        "x-tag-secret": `${secretkey}`,
      },
      data: { replaceCurrentAccount: false },
      handleSuccess: handleResponseSecretKeyActive,
      handleError: handleErrorSecretKeyActive,
    });
  };

  //============================
  // INPUT HANDLERS
  //============================
  const handleChangeRfIDToken = (e) => {
    setTokenNumber(e.target.value);
  };

  const handleChangeSecretkey = (val) => {
    setSecretkey(val);
  };

  //============================
  // RENDER
  //============================
  return (
    <TagAdd
      handleChangeRfIDToken={handleChangeRfIDToken}
      SearchToken={SearchToken}
      pageCount={pageCount}
      SubmitSecretKey={SubmitSecretKeyActive}
      handleChangeSecretkey={handleChangeSecretkey}
      secretkey={secretkey}
      loader={loader}
      askLink={askLink}
      setTokenNumber={setTokenNumber}
      tokenNumber={tokenNumber}
    />
  );
};

export default TagRechargeContainer;
